import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import { Button, Form, Tag, message, Space } from "antd";
import { IDocumentFields } from "../../../../interfaces/ICase";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import {
  deleteUploadedDocument,
  downloadDocument,
  getAllStarhealthDocumentsData,
  updateAllDocumentsData,
} from "../../../../apis/patientService";
import { UploadDocument } from "../../../../models/EnhancementSlice";
import {
  getBasicDetails,
  getDeficiencyQuestionData,
  getTimelineDetails,
} from "../../../../models/patientSlice";
import DocumentDeficiencyModal from "../../../../components/patient/DocumentDeficiencyModal";
import FilePreviewModal from "../../../../components/patient/PreAuth-query/FilePreviewModal";
import PatientDetailsStageDocument from "../../../../components/modals/PatientDetailsStageDocument";
import dayjs from "dayjs";
import { fetchStepperData } from "../../../../models/preAuthSlice";
import ConfirmSubmissionModalStage from "../../../../components/modals/ConfirmSubmissionModalStage";
import {
  intimateClaimSubmissionAyushmanB,
  submitClaimSubmissionAyushmanB,
  submitClaimSubmissionToEdgeProAyushmanB,
} from "../../../../models/preAuthClaimSlice";
import MultipleFilesPreviewModal from "../../../../components/patient/PreAuth-query/MultipleFilesPreviewModal";
import ClaimAyushman from "../../../../components/patient/Claim/Ayushman Bharat/ClaimAyushman";
import {
  fetchInvestigations,
  getPreAuthClaimAyushmanBharat,
  submitApprovalAyushmanB,
} from "../../../../apis/ayushmanBService";
import {
  getClaimDataForAyushB,
  getClaimFinanceForAyushB,
  getPortalDataForAyushB,
} from "../../../../models/ayushmanBSlice";
import {
  CloudDownloadOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import UploadDocumentInPreAuth from "../../../../components/patient/PreAuth/UploadDocumentInPreAuth";

interface Document {
  id: number;
  type?: string;
  file?: any;
  documentId?: any;
  label?: string;
  labelId?: string | number;
  documentName?: string;
  requestDocument?: boolean;
  responseDocument?: boolean;
}

interface DocumentUrl {
  documentType: string;
  documentName: string;
  documentUrl: string;
  id: number;
  referenceType: string | null;
  documentLabelType: any;
  deficiencyCheckStatus: any;
  remarks: string | null;
}

interface DocumentResponse {
  status: string;
  message?: string;
  data?: {
    documentUrl: string;
    id: number;
  };
}

interface DocumentUploadResponse extends DocumentUrl {}

interface BasicDetailsPayload {
  caseId: number;
  visitId: number;
}

type ClaimAyushmanContainerProps = {
  activeKey: any;
  sseData?: any;
  sseUpdateCount?: any;
};

const ClaimAyushmanContainer: FC<ClaimAyushmanContainerProps> = ({
  activeKey,
  sseData,
  sseUpdateCount
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { patients, auth, enhancement, preAuth, preAuthClaim, ayushBPreAuth } =
    useSelector((state: RootState) => state);
  const [selectedFile, setSelectedFile] = useState<{
    file: File;
    documentType: string;
  } | null>(null);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [isApproved, setIsApproved] = useState<boolean>(false);
  const [isApprovedInitiated, setIsApprovedInitiated] =
    useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [documentTypes, setDocumentTypes] = useState<Document[]>([]);
  const [isIntimating, setIsIntimating] = useState<boolean>(false);
  const [fetchingDeficiencyData, setFetchingDeficiencyData] =
    useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [
    documentRequestResponseDocuments,
    setDocumentRequestResponseDocuments,
  ] = useState<any>();
  const [documentUrl, setDocumentUrl] = useState<string>("");
  const [form] = Form.useForm();
  const [caseClaimId, setCaseClaimId] = useState<number | null>(null);
  const [documentUrls, setDocumentUrls] = useState<
    {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks: string | null;
    }[]
  >([]);
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [claimData, setClaimData] = useState<any>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [portalSubmission, setPortalSubmission] = useState<boolean>(false);
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [clickedActiveDocumentUrl, setClickedActiveDocumentUrl] =
    useState<any>();
  const [uploadedOtherFileList, setUploadedOtherFileList] = useState<
    IDocumentFields[]
  >([]);
  const [uploadFileModal, setUploadFileModal] = useState<boolean>(false);
  const [documentTypeList, setDocumentTypeList] = useState<{
    [key: string]: Document[];
  }>({ ["others"]: [] });
  const [formattedDocumentTypeList, setFormattedDocumentTypeList] = useState<{
    [key: string]: Document[];
  }>({ ["others"]: [] });
  const [activeDocListType, setActiveDocListType] = useState<string>("");

  const isClaimTabActive = () => {
    if (!activeKey || activeKey.length === 0) return false;

    const currentStageId =
      typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]);

    const currentStage = preAuth?.stepperData?.visitStages?.find(
      (stage: any) => stage?.visitStageId === currentStageId
    );

    return currentStage?.visitStage?.toUpperCase() === "CLAIM";
  };

  const uploadedFileColumns = [
    {
      title: "S.No.",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: 80,
      render: (text: any, records: any, index: number) => (
        <span style={{ fontWeight: "bold" }}>{index + 1}</span>
      ),
    },
    {
      title: "Document Type",
      dataIndex: "documentLabelType",
      key: "documentLabelType",
      align: "center",
      render: (text: string) => (
        <div style={{ textTransform: "initial", fontSize: "15px" }}>{text}</div>
      ),
    },
    {
      title: "Document Name",
      dataIndex: "documentName",
      key: "document",
      align: "center",
      render: (text: string) => (
        <div style={{ textTransform: "initial", fontSize: "15px" }}>{text}</div>
      ),
    },
    {
      title: "Deficiency Status",
      dataIndex: "deficiencyCheckStatus",
      key: "deficiency",
      align: "center",
      render: (text: boolean | null, record: IDocumentFields) => {
        if (record && record?.documentName) {
          setDocumentName(record?.documentName);
        }
        return text === true ? (
          <Tag color="green">Pass</Tag>
        ) : text === false ? (
          <Tag color="red">Fail</Tag>
        ) : text === null || text === undefined ? (
          <Button
            style={{
              backgroundColor: "#E0E0E0",
              borderRadius: "10px",
              color: "#222222",
              boxShadow: "0px -1px 4px 0px #00000040 inset",
            }}
            type="primary"
            onClick={() => {
              if (record?.documentType) {
                record?.documentUrl &&
                  record?.id &&
                  record &&
                  handleDeficiencyModalOpen(
                    record?.documentUrl,
                    record?.id,
                    record
                  );
              }
            }}
          >
            <span style={{ textTransform: "initial" }}>Check Deficiency</span>
          </Button>
        ) : null;
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_: any, record: IDocumentFields) => (
        <Space size="middle">
          <EyeOutlined
            style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
            onClick={() => {
              handleOpenOthers();
              record?.documentUrl && handleSetDocumentUrl(record?.documentUrl);
            }}
          />
          {/* <EditOutlined style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }} /> */}
          <CloudDownloadOutlined
            style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
            onClick={() =>
              handleDownloadDocument &&
              record?.documentName &&
              record?.documentUrl &&
              handleDownloadDocument(record?.documentName, record?.documentUrl)
            }
          />
          <DeleteOutlined
            style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
            onClick={() =>
              record?.documentType &&
              record?.documentUrl &&
              handleDeleteDocument(
                record?.documentType,
                record?.documentUrl,
                "other"
              )
            }
          />
        </Space>
      ),
    },
  ];

  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; documentType: string }[]
  >([]);
  const [previewFiles, setPreviewFiles] = useState<
    {
      url: string;
      name: string;
      showUpload: boolean;
      documentType: string;
      isMultiple: boolean;
    }[]
  >([]);
  const [uploadFileList, setUploadFileList] = useState<any[]>([]);

  useEffect(() => {
    if (!previewModalVisible) {
      setSelectedFiles([]);
    }
  }, [previewModalVisible]);

  const currentActiveStage = preAuth?.stepperData?.visitStages?.find(
    (stage: any) =>
      stage?.visitStageId ===
      (typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]))
  );

  const fetchPostInvestigation = async (
    portalMetaDataId: number,
    data: any
  ) => {
    if (portalMetaDataId && data) {
      try {
        const AllDocumentList = await fetchInvestigations(
          portalMetaDataId,
          data
        );
        let otherDocTypelist: Document[] = [];
        if (Array.isArray(AllDocumentList) && AllDocumentList.length > 0) {
          otherDocTypelist = AllDocumentList?.map((item: any) => ({
            id: item?.documentMasterId,
            label: item?.investigationName,
            labelId: item?.documentMasterId,
          }));
        }

        setDocumentTypeList((prev) => ({
          ...prev,
          ["others"]: otherDocTypelist || [],
        }));
      } catch (err) {
        errorMessage("Please, Try again after sometime");
      }
    }
  };

  //   useEffect(() => {
  //     if (documentTypes && documentUrls?.length > 0) {
  //       const filteredOthers = documentTypes?.filter(
  //         (item) =>
  //           !documentUrls?.some(
  //             (doc) => doc.documentType === String(item.labelId)
  //           )
  //       );

  //       //   setFormattedDocumentTypeList((prev) => ({
  //       //     ...prev,
  //       //     ["hospital"]: filteredOthers || []
  //       //   }))
  //       setDocumentTypes(filteredOthers);
  //     }
  //   }, [documentUrls]);

  useEffect(() => {
    if (documentTypeList?.others) {
      const filteredOthers = documentTypeList?.others.filter(
        (item) =>
          !uploadedOtherFileList.some(
            (doc) => doc.documentType === String(item.labelId)
          )
      );

      setFormattedDocumentTypeList((prev) => ({
        ...prev,
        ["others"]: filteredOthers || [],
      }));
    }
  }, [uploadedOtherFileList, documentTypeList?.others]);

  const getAttachmentsWithValues = (
    attchmentData: any,
    key: string = "hospital"
  ) => {
    if (attchmentData) {
      if (key == "hospital") setDocumentUrls(attchmentData);
      if (key == "other") setUploadedOtherFileList(attchmentData);
    }
  };

  useEffect(() => {
    if (
      ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.treatmentPlansData
        ?.length > 0 &&
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0]
    ) {
      const procedureCodeList =
        ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.treatmentPlansData?.map(
          (item: any) => {
            return item?.procedure?.id;
          }
        );

      const investigationPlayload = {
        procedureCodes: procedureCodeList,
        investigationStage: "Post",
      };
      fetchPostInvestigation(
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
        investigationPlayload
      );
    }
  }, [
    ayushBPreAuth?.portalData,
    patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
  ]);

  useEffect(() => {
    if (claimData) {
      setPortalSubmission(claimData?.submitted);
    }
  }, [claimData]);

  const schemeMetaDataId =
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;
  const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
  const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

  useEffect(() => {
    const listOfUploadedDocuments = documentTypes?.flatMap(
      (item: any) =>
        item?.documentList?.map((doc: any) => ({
          id: doc?.id,
          documentName: doc?.documentName,
          documentType: doc?.documentType,
          documentUrl: doc?.documentUrl,
          documentLabelType: doc?.documentLabelType,
          deficiencyCheckStatus: doc?.deficiencyCheckStatus,
        })) || []
    );

    setDocumentUrls(listOfUploadedDocuments);
  }, [documentTypes]);

  useEffect(() => {
    if (ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId) {
      dispatch(
        getClaimFinanceForAyushB({
          claimId:
            ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId,
        })
      );
    }
  }, [ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId]);

  const handleGetData = async () => {
    if (
      caseId &&
      visitId &&
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0]
    ) {
      await dispatch(
        getClaimDataForAyushB({
          caseId,
          visitId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
        })
      );
      fetchStepperForStatus();
    }
  };

  useEffect(() => {
    if (ayushBPreAuth?.claim?.caseData) {
      if (ayushBPreAuth?.claim?.caseData)
        getAttachmentsWithValues(
          ayushBPreAuth?.claim?.caseData?.hospitalDocuments,
          "hospital"
        );
      if (ayushBPreAuth?.claim?.caseData)
        getAttachmentsWithValues(
          ayushBPreAuth?.claim?.caseData?.otherDocuments,
          "other"
        );

      // setClaimId(ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId || "");
    }
  }, [ayushBPreAuth?.claim?.caseData]);

  const handleGetPortalData = () => {
    if (caseId && visitId) {
      dispatch(getPortalDataForAyushB({ caseId, visitId }));
    }
  };

  const handleFileChange =
    (documentType: string, isMultiple: boolean) => (e: any) => {
      if (isMultiple) {
        const files = e?.fileList || [];
        setUploadFileList(files);
        if (files.length === 0) return;

        const selected = files?.map((f: any) => ({
          file: f.originFileObj,
          documentType,
        }));

        const previews = files?.map((f: any) => ({
          url: URL.createObjectURL(f.originFileObj),
          name: f.name,
          showUpload: true,
          documentType,
          isMultiple: isMultiple,
        }));

        setSelectedFiles(selected);
        setPreviewFiles(previews);
        setPreviewModalVisible(true);
      } else {
        if (Array.isArray(e)) {
          return e;
        }
        if (e?.file) {
          setSelectedFile({ file: e.file, documentType: documentType });
          setPreviewFile({
            url: URL.createObjectURL(e.file),
            name: e.file.name,
            showUpload: true,
            documentType: documentType,
          });
          setPreviewModalVisible(true);
        }
        return e?.target?.files;
      }
    };

  // const handleFileChange = (documentType: string) => (e: any) => {
  //   const maxSize = 15 * 1024 * 1024;

  //   if (Array.isArray(e)) {
  //     return e;
  //   }
  //   if (e?.file) {
  //     setSelectedFile({ file: e.file, documentType: documentType });
  //     setPreviewFile({
  //       url: URL.createObjectURL(e.file),
  //       name: e.file.name,
  //       showUpload: true,
  //       documentType: documentType,
  //     });
  //     setPreviewModalVisible(true);
  //   }
  //   return e?.target?.files;
  // };

  const fetchDocuments = async () => {
    if (schemeMetaDataId && caseId && visitId) {
      try {
        setLoading(true);
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId
        );

        setDocumentTypes(AllDocumentList?.["Claim"]);
      } catch (err) {
        errorMessage("Please, Try again after sometime");
      } finally {
        setLoading(false);
      }
    }
  };

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any
  ) => {
    try {
      if (selectedDocumentId) {
        // dispatch(clearDeficiencyCheck());
        // const firstRes = await dispatch(
        //   getDeficiencyQuestions(selectedDocumentId)
        // );
        setFetchingDeficiencyData(true);
        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocumentId)
        );
        setFetchingDeficiencyData(false);
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
      setFetchingDeficiencyData(false);
    }
  };

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: any
  ) => {
    await fetchDeficiencyData(document, document?.id);
    setPreviewDocumentUrl(documentUrl);
    // setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  useEffect(() => {
    const requestResponseDocuments = {
      requestedDocuments: [] as Document[],
      responseDocuments: [] as Document[],
    };

    documentTypes?.forEach((document) => {
      if (document?.requestDocument || true) {
        requestResponseDocuments.requestedDocuments.push(document);
      } else if (document?.responseDocument) {
        requestResponseDocuments.responseDocuments.push(document);
      }
    });

    setDocumentRequestResponseDocuments(requestResponseDocuments);
  }, [documentTypes]);

  const getClaimData = async () => {
    try {
      if (caseId && visitId) {
        const res = await getPreAuthClaimAyushmanBharat(
          caseId,
          visitId,
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0]
        );

        if (
          res?.claimSubmissionRes &&
          typeof res?.claimSubmissionRes === "object"
        ) {
          setClaimData(res.claimSubmissionRes);
          setCaseClaimId(res.claimSubmissionRes.id);
          setIsApproved(res.claimSubmissionRes.approved);

          const updatedValues = {
            ...res?.claimSubmissionRes,
            dateOfAdmission: res?.claimSubmissionRes?.dateOfAdmission
              ? dayjs(
                  res?.claimSubmissionRes?.dateOfAdmission,
                  "DD-MM-YYYY HH:mm:ss"
                )
              : null,
            ...res?.claimSubmissionRes?.hospitalBill,
            billDate: res?.claimSubmissionRes?.billDate
              ? dayjs(res?.claimSubmissionRes?.billDate, "DD-MM-YYYY HH:mm:ss")
              : null,
          };

          form.setFieldsValue(updatedValues);
        }
      }
    } catch (err: any) {
      errorMessage(err?.message || "Please, Try again later");
    }
  };

  const fetchDataForSse = async () => {
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      // dispatch(
      //   getBasicDetails({
      //     id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
      //   })
      // );
    }
    getClaimData();
    await handleGetData();
    fetchStepperForStatus();
    await getTimelineDetail();
    fetchDocuments();
  };

  useEffect(() => {
    if (sseData) {
      fetchDataForSse();
    }
  }, [sseData, sseUpdateCount]);

  const fetchStepperForStatus = async () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      await dispatch(fetchStepperData({ caseId: caseId, visitId: visitId }));
    }
  };

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
  };

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isClaimTabActive()) {
      // fetchStepperForStatus();
      // getTimelineDetail();
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      await getClaimData();
      await handleGetData();
      handleGetPortalData();
      await fetchDocuments();
    };

    if (activeKey && activeKey?.length > 0 && isClaimTabActive()) fetchData();
  }, [schemeMetaDataId, activeKey]);

  const handleOpen = (docType: any, documentUrl: any) => {
    setPreviewDocument(true);
    setClickedActiveTab(docType);
    setClickedActiveDocumentUrl(documentUrl);
  };

  const handleCancelPreview = () => {
    setPreviewModalVisible(false);
    setSelectedFile(null);
    setPreviewDocument(false);
  };

  const validateRequiredDocuments = (
    mandatoryDocuments: any,
    documentUrls: any
  ) => {
    for (const doc of mandatoryDocuments) {
      if (doc.required) {
        const isUploaded = documentUrls?.some(
          (uploadedDoc: any) => uploadedDoc.documentLabelType === doc.label
        );
        if (!isUploaded) {
          return false;
        }
      }
    }
    return true;
  };

  const updateOrAddDocument = (
    uploadedDocumentUrl: any,
    documentRes: IDocumentFields
  ) => {
    const updatedDocuments = [...uploadedDocumentUrl];
    const documentIndex = updatedDocuments.findIndex(
      (doc) => doc.documentType === documentRes.documentType
    );

    if (
      documentIndex !== -1 &&
      documentRes?.documentType?.toUpperCase() !== "DOCUMENT" &&
      documentRes?.documentLabelType?.toUpperCase() !== "AUDITED BILL" &&
      documentRes?.documentLabelType?.toUpperCase() !== "HOSPITAL BILL" &&
      documentRes?.documentLabelType?.toUpperCase() !== "COVID TEST REPORT" &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Unlisted Procedure Docs"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Unlisted Procedure Permission"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Consultation Notes"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "DISCHARGE SUMMARY"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "DRUG CERTIFICATE"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "DEATH CERTIFICATE"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "ECHS CARD COPY"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "EMERGENCY LETTER"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "OTHERS"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "LAB REPORTS"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "SELF ATTESTED PROFORMA"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !== "MLC"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Contingent Bill"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Copy of Cancelled Cheque"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Delay Condonation Letter (Intimation)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Delay Condonation Letter (Submission)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Disability Certificate (Intimation)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Disability Certificate (Submission)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Doctor Certificate"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !== "EIR"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Extended Stay Certificate"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Extension of Stay - Approval"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Extension of Stay - Permission"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Feedback Form"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Geo-Tagged Photo of Patient"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Medical Reports"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Medicine Issue Slip"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "NA Certificate"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Outer Pack of Implants"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Personal Application"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Prescription Slip"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Referral Letter (By Polyclinic)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Emergency Letter (By Hospital)"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Sanction Letter"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Service Specialist Recommendation"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Stay Extension Documents"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Supplimentary Justification Document"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Supplimentary Sanction Document"?.toUpperCase() &&
      documentRes?.documentLabelType?.toUpperCase() !==
        "Unlisted Procedure Approval"?.toUpperCase()
    ) {
      updatedDocuments[documentIndex] = {
        ...updatedDocuments[documentIndex],
        documentName: documentRes?.documentName,
        documentUrl: documentRes?.documentUrl,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
      };
    } else {
      updatedDocuments.push({
        documentType: documentRes.documentType,
        documentName: documentRes.documentName,
        documentUrl: documentRes.documentUrl,
        documentLabelType: documentRes?.documentLabelType,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
      });
    }
    return updatedDocuments;
  };

  const handleSubmit = async () => {
    try {
      // await form.validateFields();
      const values = await form.getFieldsValue(true);

      const updatedValues = {
        ...values,
        status: true,
        claimNo: values?.claimNo,
        billDate: values?.billDate
          ? dayjs(values?.billDate, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        hospitalBill: {
          billDate: values?.billDate
            ? dayjs(values?.billDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          billAmount: values?.billAmount,
          billNumber: values?.billNumber,
        },
        hospitalDocuments: documentUrls,
        otherDocuments: uploadedOtherFileList,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
      };

      setIsSaving(true);

      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id &&
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds
      ) {
        setIsSaving(true);
        const resp = await dispatch(
          submitClaimSubmissionToEdgeProAyushmanB({
            data: updatedValues,
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            portalId:
              patients?.fetchBasicDetails?.casesResponse
                ?.portalMetaDataIds?.[0],
            caseClaimId: caseClaimId,
            // caseClaimId: null,
          })
        );
        setIsSaving(false);

        if (submitClaimSubmissionToEdgeProAyushmanB.fulfilled.match(resp)) {
          successMessage("Claim Saved Successfully");
          setConfirmationModal(false);
          await getClaimData();
          await handleGetData();
          await fetchStepperForStatus();
          await getTimelineDetail();
          await fetchDocuments();
          if (visitId) {
            dispatch(
              getBasicDetails({
                id: visitId,
              })
            );
          }
        } else if (
          submitClaimSubmissionToEdgeProAyushmanB.rejected.match(resp)
        ) {
          errorMessage("Please, Try again later");
          setConfirmationModal(false);
          setIsSaving(false);
        }
      }
    } catch (error: any) {
      if (error?.errorFields) {
        errorMessage("Please, fill all details before submitting");
        setIsSaving(false);
        setConfirmationModal(false);
      } else {
        errorMessage(error?.message || "Something went wrong");
        setIsSaving(false);
        setConfirmationModal(false);
      }
    } finally {
      setIsSaving(false);
      setConfirmationModal(false);
    }
  };

  const handleSubmitOnPortal = async () => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);

      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        const updatedValues = {
          ...values,
          status: true,
          claimNo: values?.claimNo,
          hospitalDocuments: documentUrls,
          otherDocuments: uploadedOtherFileList,
          billDate: values?.billDate
            ? dayjs(values?.billDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          hospitalBill: {
            billDate: values?.billDate
              ? dayjs(values?.billDate, "DD-MM-YYYY HH:mm:ss").format(
                  "DD-MM-YYYY HH:mm:ss"
                )
              : null,
            billAmount: values?.billAmount,
            billNumber: values?.billNumber,
          },
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
        };

        setIsSubmitting(true);

        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id &&
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds
        ) {
          setIsSubmitting(true);
          const resp = await dispatch(
            submitClaimSubmissionAyushmanB({
              data: updatedValues,
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              portalId:
                patients?.fetchBasicDetails?.casesResponse
                  ?.portalMetaDataIds?.[0],
              // caseClaimId: null
            })
          );
          setIsSubmitting(false);

          if (submitClaimSubmissionAyushmanB.fulfilled.match(resp)) {
            successMessage("Claim Submitted Successfully");
            setConfirmationModal(false);
            await getClaimData();
            await handleGetData();
            await fetchStepperForStatus();
            await getTimelineDetail();
            await fetchDocuments();
            if (visitId) {
              dispatch(
                getBasicDetails({
                  id: visitId,
                })
              );
            }
          } else if (submitClaimSubmissionAyushmanB.rejected.match(resp)) {
            errorMessage("Please, Try again later");
            setConfirmationModal(false);
            setIsSubmitting(false);
          }
        }
      } else {
        errorMessage("Please, Upload all required documents");
        setConfirmationModal(false);
        setIsSubmitting(false);
      }
    } catch (error: any) {
      if (error?.errorFields) {
        errorMessage("Please, fill all details before submitting");
        setIsSubmitting(false);
        setConfirmationModal(false);
      } else {
        errorMessage(error?.message || "Something went wrong");
        setConfirmationModal(false);
        setIsSubmitting(false);
      }
    } finally {
      setIsSubmitting(false);
      setConfirmationModal(false);
    }
  };

  const handleApprove = async () => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);

      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        setIsApprovedInitiated(true);
        const updatedValues = {
          ...values,
          status: true,
          billDate: values?.billDate
            ? dayjs(values?.billDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          hospitalBill: {
            billDate: values?.billDate
              ? dayjs(values?.billDate, "DD-MM-YYYY HH:mm:ss").format(
                  "DD-MM-YYYY HH:mm:ss"
                )
              : null,
            billAmount: values?.billAmount,
            billNumber: values?.billNumber,
          },
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          hospitalDocuments: documentUrls,
          otherDocuments: uploadedOtherFileList,
        };

        const formData = {
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          stage: "Claim",
          approved: true,
          claimRequest: updatedValues,
          caseClaimSubmissionId: caseClaimId,
        };

        const res = await submitApprovalAyushmanB(formData);
        setIsApproved(true);
        setIsApprovedInitiated(false);
        message.success("Claim Approved Successfully");
        setConfirmationModal(false);
        await getTimelineDetail();
        await fetchStepperForStatus();
        await getClaimData();
        await handleGetData();
        await fetchDocuments();
        if (visitId) {
          dispatch(
            getBasicDetails({
              id: visitId,
            })
          );
        }
      } else {
        errorMessage("Please, Upload all required documents");
        setConfirmationModal(false);
        setIsApprovedInitiated(false);
        setIsApproved(false);
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, fill all details before submitting");
        setIsApprovedInitiated(false);
        setIsApproved(false);
      } else {
        errorMessage("Please, Try again later");
        setIsApprovedInitiated(false);
        setIsApproved(false);
      }
      setConfirmationModal(false);
    }
  };

  const handleAttachDocuments = async (updatedDocumentUrls: any) => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
    };

    payloadSchema["caseClaimAttachments"] = updatedDocumentUrls;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema
        );
        message.success(`documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleSaveData = async () => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
    };

    const updatedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments["responseDocuments"]?.some(
        (doc: any) => doc?.label === document?.documentLabelType
      )
    );

    payloadSchema["caseClaimAttachments"] = updatedDocumentUrls;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema
        );
        message.success(`Response documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleIntimate = async () => {
    try {
      // await form.validateFields();
      const values = await form.getFieldsValue(true);
      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        const updatedValues = {
          ...values,
          status: true,
          claimNo: values?.claimNo,
          billDate: values?.billDate
            ? dayjs(values?.billDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          hospitalBill: {
            billDate: values?.billDate
              ? dayjs(values?.billDate, "DD-MM-YYYY HH:mm:ss").format(
                  "DD-MM-YYYY HH:mm:ss"
                )
              : null,
            billAmount: values?.billAmount,
            billNumber: values?.billNumber,
          },
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          action: "intimate",
          hospitalDocuments: documentUrls,
          otherDocuments: uploadedOtherFileList,
        };

        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id &&
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds
        ) {
          setIsIntimating(true);
          const resp = await dispatch(
            intimateClaimSubmissionAyushmanB({
              data: updatedValues,
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
              portalId:
                patients?.fetchBasicDetails?.casesResponse
                  ?.portalMetaDataIds?.[0],
              caseClaimId: caseClaimId,
              // caseClaimId: null,
            })
          );
          setIsIntimating(false);

          if (intimateClaimSubmissionAyushmanB.fulfilled.match(resp)) {
            successMessage("Claim Sent To QC Successfully");
            setConfirmationModal(false);
            await getClaimData();
            await handleGetData();
            await fetchStepperForStatus();
            await getTimelineDetail();
            await fetchDocuments();
            if (visitId) {
              dispatch(
                getBasicDetails({
                  id: visitId,
                })
              );
            }
          } else if (intimateClaimSubmissionAyushmanB.rejected.match(resp)) {
            errorMessage("Please, Try again later");
            setIsIntimating(false);
            setConfirmationModal(false);
          }
        }
      } else {
        errorMessage("Please, Upload all required documents");
        setConfirmationModal(false);
        setIsIntimating(false);
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, fill all details before submitting");
      } else {
        errorMessage("Please, Try again later");
      }
      setIsIntimating(false);
      setConfirmationModal(false);
    }
  };

  const handleDeleteProcedure = (procedure: any): boolean => {
    try {
      if (!caseId || !visitId || !caseClaimId) {
        errorMessage("Required information not found");
        return false;
      }

      // Call the API asynchronously but return immediately
      deleteUploadedDocument(caseId)
        .then((response) => {
          if (response?.status === "success") {
            successMessage("Procedure deleted successfully");
          }
        })
        .catch((error: any) => {
          errorMessage(error?.message || "Failed to delete procedure");
        });

      return true;
    } catch (error: any) {
      errorMessage(error?.message || "Failed to delete procedure");
      return false;
    }
  };

  const handleUpload = async () => {
    if (selectedFiles?.length > 0) {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
        );
      }
      CollectPostData.append("documentType", previewFiles?.[0]?.documentType);

      selectedFiles?.map((fileObj, index) =>
        CollectPostData.append(`file${index}`, fileObj.file)
      );

      // if (selectedFiles?.length > 0) {
      //   selectedFiles.forEach((fileObj, index) => {
      //     // Extract the actual File object from your structure
      //     const actualFile = fileObj.file; // This is the originFileObj (actual File)

      //     if (actualFile instanceof File) {
      //       CollectPostData.append("files", actualFile);
      //     }
      //   });
      // }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          })
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`
        );
        await handleAttachDocuments(documentRes);
        setUploadFileList([]);
        setSelectedFiles([]);
        setPreviewFiles([]);
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    } else {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
        );
      }
      CollectPostData.append("documentType", previewFile.documentType);

      if (selectedFile?.file) {
        CollectPostData.append("file", selectedFile?.file);
      }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          })
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`
        );
        await handleAttachDocuments(documentRes);
        setSelectedFile(null);
        setPreviewFile({
          url: "",
          name: "",
          showUpload: false,
          documentType: "",
        });
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    }
  };

  const handleUploadDocument = async () => {
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id.toString()
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }
    CollectPostData.append("documentType", previewFile.documentType);

    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file);
    }

    try {
      const resp = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      );
      if (UploadDocument.fulfilled.match(resp)) {
        const documentList = uploadedOtherFileList;
        // const updatedDocuments = updateOrAddDocument(
        //   documentList,
        //   resp?.payload
        // );
        const updatedDocuments = [...documentList, ...resp?.payload];
        if (resp?.payload?.length > 0) {
          message.success(
            `${resp?.payload?.[0]?.documentLabelType} uploaded successfully`
          );
          if (activeDocListType == "other")
            setUploadedOtherFileList(updatedDocuments);
        } else {
          message.error("Please Upload Again");
        }
        setUploadFileModal(false);
      } else if (UploadDocument.rejected.match(resp)) {
        errorMessage("FAILED TO UPLOAD DOCUMENT");
      }
    } catch (error) {
      console.error("Failed to upload document:", error);
    }
  };

  const handleModalOpen = (lisType: any) => {
    setIsModalOpen(true);
    setActiveDocListType(lisType);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setUploadFileModal(false);
  };

  // const handleUpload = async () => {
  //   const CollectPostData = new FormData();
  //   if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
  //     CollectPostData.append(
  //       "hospitalId",
  //       patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.patientResponse?.id) {
  //     CollectPostData.append(
  //       "patientId",
  //       patients?.fetchBasicDetails?.patientResponse?.id?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.casesResponse?.id) {
  //     CollectPostData.append(
  //       "caseId",
  //       patients?.fetchBasicDetails?.casesResponse?.id?.toString()
  //     );
  //   }
  //   if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
  //     CollectPostData.append(
  //       "visitId",
  //       patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
  //     );
  //   }
  //   CollectPostData.append("documentType", previewFile.documentType);

  //   if (selectedFile?.file) {
  //     CollectPostData.append("file", selectedFile?.file);
  //   }

  //   try {
  //     const documentRes = await dispatch(
  //       UploadDocument({
  //         formData: CollectPostData,
  //         accessToken: auth.accessToken || "",
  //       })
  //     ).unwrap();

  //     const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);

  //     setDocumentUrls(updatedDocuments);
  //     setPreviewModalVisible(false);
  //     message.success(
  //       `${documentRes?.documentLabelType} uploaded successfully`
  //     );
  //   } catch (error) {
  //     console.error("Failed to upload document:", error);
  //   }
  // };

  const handleDeleteDocument = async (
    docType: string,
    documentUrl: string,
    activeDocListType: any = "hospital"
  ) => {
    let deleteDocument;
    if (activeDocListType == "hospital") {
      deleteDocument = documentUrls?.find(
        (doc, index) => doc?.documentUrl === documentUrl
      );
    }
    if (activeDocListType == "other") {
      deleteDocument = uploadedOtherFileList?.find(
        (doc, index) => doc?.documentUrl === documentUrl
      );
    }
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };
    let newUpdatedDocumentList: any;
    if (activeDocListType == "hospital") {
      newUpdatedDocumentList = documentUrls?.filter(
        (doc, index) => doc?.documentUrl !== documentUrl
      );
    }
    if (activeDocListType == "other") {
      newUpdatedDocumentList = uploadedOtherFileList?.filter(
        (doc, index) => doc?.documentUrl !== documentUrl
      );
    }
    // dispatch(setUploadedDocumentUrl(newUpdatedDocumentList));
    if (deleteDocument?.documentUrl) {
      const res = await deleteUploadedDocument(deleteForm);
      if (res) {
        message.success("Document Deleted Successfully!");
        if (activeDocListType == "hospital")
          setDocumentUrls(newUpdatedDocumentList || []);
        if (activeDocListType == "other")
          setUploadedOtherFileList(newUpdatedDocumentList || []);
      }
    }
  };

  const handleSetDocumentUrl = (url: string) => {
    setDocumentUrl(url);
  };

  const handleOpenOthers = () => {
    setPreviewDocument(true);
  };

  const handleDeficiencyModalOpenOthers = async (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields
  ) => {
    await fetchDeficiencyData(document, documentId);
    setPreviewDocumentUrl(documentUrl);
    // setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const closeDeficiencyModalOthers = () => {
    setDeficiencyModal(false);
    // setSelectedDocumentId(null);
    setSelectedDocument(null);
  };

  const handleBasicDetailsUpdate = async () => {
    if (!caseId || !visitId) {
      errorMessage("Required information not found");
      return;
    }

    try {
      await dispatch(getBasicDetails({ id: caseId }));
      await dispatch(getTimelineDetails({ caseId, visitId }));
      await dispatch(fetchStepperData({ caseId, visitId }));
    } catch (error: any) {
      errorMessage(error?.message || "Failed to update details");
    }
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      successMessage("document downloaded successfully");
    } catch (err) {
      errorMessage("Please, Try again later");
    }
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number
  ) => {
    const combinedUrls: any = [...documentUrls];
    const deleteDocument = combinedUrls?.find(
      (doc: any, index: any) => doc?.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };

    const newUpdatedDocumentList = documentUrls?.filter(
      (doc: any, index: any) => doc?.documentUrl !== documentUrl
    );
    setDocumentUrls(newUpdatedDocumentList);

    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
      } catch (err) {
        console.error(err);
        message.error("Please, Try again later");
      }
      // fetchDocuments();
    }
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocument(null);
  };

  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("");
  const [confirmationState, setConfirmationState] = useState<string>("");

  const handleSaveConfirmationModal = async (confirmationState: string) => {
    if (confirmationState === "intimate") {
      try {
        await form.validateFields();
      } catch (err: any) {
        if (err?.errorFields) {
          errorMessage("Please, fill all details before submitting");
        } else {
          errorMessage("Please, Try again later");
        }
        return;
      }
      if (
        !validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls,
        )
      ) {
        errorMessage("Please, Upload all required documents");
        return;
      }
    }

    setConfirmationModal(true);
    setConfirmationState(confirmationState);

    if (confirmationState === "save") {
      setTitle("Do You want to save Claim ?");
    } else if (confirmationState === "update") {
      setTitle("Do You want to update Claim ?");
    } else if (confirmationState === "submit") {
      setTitle("Do You want to submit Claim ?");
    } else if (confirmationState === "approve") {
      setTitle("Do You want to approve Claim ?");
    } else if (confirmationState === "intimate") {
      setTitle("Do you want to send Claim for QC ?");
    }
  };

  const handleSave = async () => {
    if (confirmationState === "save") {
      await handleSubmit();
    } else if (confirmationState === "update") {
      await handleSubmit();
    } else if (confirmationState === "submit") {
      await handleSubmitOnPortal();
    } else if (confirmationState === "approve") {
      await handleApprove();
    } else if (confirmationState === "intimate") {
      await handleIntimate();
    }

    setConfirmationModal(false);
  };

  return (
    <>
      <ClaimAyushman
        claimData={claimData}
        // isEditable={!(claimData?.submitted || claimData?.approved)}
        isEditable={!claimData?.submitted}
        caseClaimSubmissionId={caseClaimId}
        portalSubmission={portalSubmission}
        handleDeleteProcedure={handleDeleteProcedure}
        form={form}
        activeKey={activeKey}
        handleFileChange={handleFileChange}
        handleSaveData={handleSaveData}
        handleOpen={handleOpen}
        preAuth={preAuth}
        loading={loading}
        documentRequestResponseDocuments={documentRequestResponseDocuments}
        documentTypes={documentTypes}
        documentUrls={documentUrls}
        isApproved={isApproved}
        isSaving={isSaving}
        isIntimating={isIntimating}
        handleSaveConfirmationModal={handleSaveConfirmationModal}
        isApprovedInitiated={isApprovedInitiated}
        isSubmitting={isSubmitting}
        caseClaimId={caseClaimId}
        uploadFileList={uploadFileList}
        handleModalOpen={handleModalOpen}
        uploadedFileColumns={uploadedFileColumns}
        uploadedOtherFileList={uploadedOtherFileList}
      />

      {previewModalVisible &&
        selectedFile &&
        selectedFile?.file &&
        !selectedFiles?.length && (
          <FilePreviewModal
            isVisible={previewModalVisible}
            onClose={() => setPreviewModalVisible(false)}
            fileUrl={previewFile.url}
            fileName={previewFile.name}
            documentType={previewFile.documentType}
            handleUpload={handleUpload}
            showUploadButton={true}
            key={selectedFile?.file?.lastModified || "no-file"}
            isLoading={enhancement?.isLoading}
          />
        )}

      {previewDocument && (
        <PatientDetailsStageDocument
          handleCancel={handleCancelPreview}
          handleDeleteDocument={handleDeleteList}
          open={previewDocument}
          handleDownloadDocument={handleDownloadDocument}
          // handleSetDocumentUrl={handleSetDocumentUrl}
          documents={documentUrls}
          handleDeficiencyModal={handleDeficiencyModalOpen}
          closeDeficiencyModal={closeDeficiencyModal}
          deficiencyModal={deficiencyModal}
          deficiencyQuestions={patients?.deficiencyCheckQuestions}
          setDocumentName={setDocumentName}
          selectedDocument={selectedDocument}
          setUploadedDocumentUrl={setDocumentUrls}
          activeKey={activeKey}
          clickedActiveTab={clickedActiveTab}
          isSubmittedStatus={portalSubmission}
          fetchingDeficiencyData={fetchingDeficiencyData}
          clickedActiveDocumentUrl={clickedActiveDocumentUrl}
        />
      )}

      {deficiencyModal && selectedDocument && (
        <DocumentDeficiencyModal
          key={previewDocumentUrl}
          deficiencyModal={deficiencyModal}
          closeDeficiencyModal={() => setDeficiencyModal(false)}
          documentUrl={previewDocumentUrl}
          documentName={documentName}
          handleDownloadDocument={handleDownloadDocument}
          deficiencyQuestions={patients?.deficiencyCheckQuestions}
          selectedDocument={selectedDocument}
          setUploadedDocumentUrl={setDocumentUrls}
        />
      )}

      <ConfirmSubmissionModalStage
        open={confirmationModal}
        title={title}
        handleCancel={() => setConfirmationModal(false)}
        handleSave={handleSave}
        isLoading={
          isSaving || isApprovedInitiated || isSubmitting || isIntimating
        }
      />

      {activeDocListType === "other" ? (
        <UploadDocumentInPreAuth
          // title="Confirm Document Upload"
          visible={isModalOpen}
          documentTypes={formattedDocumentTypeList[activeDocListType]}
          setDocumentTypes={setDocumentTypeList}
          // activeDocListType={activeDocListType}
          // onOk={handleModalOk}
          onCancel={handleModalClose}
          setDocumentUrls={setUploadedOtherFileList}
        />
      ) : (
        <></>
      )}

      {selectedFiles?.length > 0 && (
        <MultipleFilesPreviewModal
          isVisible={previewModalVisible}
          onClose={() => {
            setPreviewModalVisible(false);
            setSelectedFiles([]);
            setUploadFileList([]);
          }}
          files={previewFiles}
          handleUpload={handleUpload}
          showUploadButton={previewFiles?.some((f) => f.showUpload)}
          key={previewFiles?.map((f) => f.name).join(",") || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}
    </>
  );
};

export default ClaimAyushmanContainer;
